import { Injectable } from '@angular/core';
import { BrowserNavigationService } from './browser-navigation.service';


@Injectable()
export class WebBrowserNavigationService extends BrowserNavigationService {
  open(url: string, target: '_blank' | '_self' = '_blank'): void {
    const newTab = window.open(url, target);

    if (newTab) {
      newTab.focus();
    }
  }
}